import styled from 'styled-components';

const Container = ({ children }: any) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default Container;

const StyledContainer = styled.div`
  padding: 35px 60px 40px 60px;
  background-color: #FFFFFF;
  border-radius: 20px;
  border: 1px solid #D9D9D9;
  // &:hover {
  //   background-color: #f3f3f3;
  // }
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  `;
